import React, { useState, useEffect } from "react";

import {
  Typography,
  Button,
  ButtonGroup,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  ListItemSecondaryAction,
  IconButton,
  Divider,
  Paper,
  Menu,
  MenuItem,
  MenuList,
  LinearProgress,
  ClickAwayListener,
  Grow,
  Popper,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { orange, grey, green } from "@material-ui/core/colors";

import {
  CheckIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  DropDownIcon,
  ExpandMoreIcon,
  RedoIcon,
  XIcon,
} from "../../../components/common/iconography";
import OperatorsList from "./OperatorsList";
import AuditItem from "./AuditItem";

const useStyles = makeStyles((theme) => ({
  listRoot: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  listHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: theme.spacing(1.25),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2.5),
    marginTop: theme.spacing(2),
  },
  headerText: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  orange: {
    color: theme.palette.getContrastText(orange[100]),
    backgroundColor: orange[100],
  },
  green: {
    color: theme.palette.getContrastText(green[200]),
    backgroundColor: green[200],
  },
  unprocessedItem: {
    color: theme.palette.getContrastText(grey[300]),
    backgroundColor: grey[300],
  },
  backToInventory: {
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(4),
  },
  listAuditProgress: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  operators: {
    display: "flex",
    justifyContent: "center",
    margin: theme.spacing(2),
    flexWrap: "wrap",
  },
  item: {
    margin: theme.spacing(0.5),
  },
  notFound: {
    display: "fles",
    margin: theme.spacing(2),
  },
}));

export const InventoryList = ({
  handleSkip,
  handleComplete,
  handleBack,
  handleNext,
  currentAudit,
  inventories,
  isCompleted,
  title,
  disableBack,
  returnToAudit,
  locations,
  completedLocations,
  setLocationMode,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [listMode, setListMode] = useState(true);
  const [currentInventory, setCurrentInventory] = useState({});
  const classes = useStyles();

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (item) => {
    setAnchorEl(null);
  };

  const getIcon = (inventory) => {
    if (
      currentAudit.processedItems.findIndex((itm) => itm.id === inventory.id) >=
      0
    )
      return <CheckIcon fontSize="inherit" />;
    else if (
      currentAudit.skippedItems.findIndex((itm) => itm.id === inventory.id) >= 0
    )
      return <RedoIcon fontSize="inherit" />;
    return <XIcon fontSize="inherit" />;
  };

  const getAvatarClassName = (inventory) => {
    if (
      currentAudit.processedItems.findIndex((itm) => itm.id === inventory.id) >=
      0
    ) {
      if (inventory.quantityPhysical === inventory.quantityOnHand)
        return classes.green;
      else return classes.orange;
    }
    return classes.unprocessedItem;
  };

  const handleSelect = (inventory, closeMenuFlag) => {
    setCurrentInventory(inventory);
    setListMode(false);
    closeMenuFlag && handleClose(inventory);
  };

  return !currentAudit?.id ? (
    <></>
  ) : listMode ? (
    <Paper className={classes.listRoot}>
      <div>
        <div className={classes.listHeader}>
          <IconButton edge="end" onClick={handleBack} disabled={disableBack}>
            <ChevronLeftIcon fontSize="large" />
          </IconButton>
          <div className={classes.headerText}>
            <Typography color="textPrimary" variant="h5">
              {title}
            </Typography>
            {currentAudit.skippedItems?.length > 0 && (
              <>
                <IconButton edge="end">
                  <ExpandMoreIcon onClick={handleClick} fontSize="large" />
                </IconButton>
                <Menu
                  id="skipped-items-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  {currentAudit.skippedItems.map((item) => (
                    <MenuItem
                      key={item.id}
                      onClick={() => handleSelect(item, true)}
                    >
                      {
                        <Typography component="p">
                          Location: {item.location.name}, Lot# {item.lotNumber}
                        </Typography>
                      }
                    </MenuItem>
                  ))}
                </Menu>
              </>
            )}
          </div>
          <IconButton edge="start" onClick={handleNext}>
            <ChevronRightIcon fontSize="large" />
          </IconButton>
        </div>
        <div className={classes.listAuditProgress}>
          <LinearProgress
            color="secondary"
            variant="determinate"
            value={(completedLocations / locations.length) * 100}
          />
        </div>
        {currentAudit?.nextItems && (
          <OperatorsList
            currentAudit={currentAudit}
            locations={locations}
            classes={classes}
          />
        )}
      </div>
      <List className={classes.listRoot}>
        {inventories.length > 0 ? (
          inventories.map((inventory) => {
            return (
              <div key={inventory.id}>
                <ListItem onClick={() => handleSelect(inventory)}>
                  <ListItemAvatar>
                    <Avatar className={getAvatarClassName(inventory)}>
                      {/* <CropDinOutlinedIcon /> */}
                      {getIcon(inventory)}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={inventory.productName}
                    secondary={
                      inventory.accountName + " - " + inventory.lotNumber
                    }
                  />
                  <ListItemSecondaryAction>
                    <IconButton
                      edge="end"
                      onClick={() => handleSelect(inventory)}
                    >
                      <ChevronRightIcon fontSize="large" />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
                <Divider />
              </div>
            );
          })
        ) : (
          <Typography className={classes.notFound}>
            No inventories shipments found.
          </Typography>
        )}
      </List>
      <div className={classes.backToInventory}>
        <Button size="large" onClick={handleBack} disabled={disableBack}>
          Back
        </Button>
        <SplitButton
          returnToAudit={returnToAudit}
          setLocationMode={setLocationMode}
          isCompleted={isCompleted}
        />
        <Button size="large" onClick={handleNext} color="primary">
          Next
        </Button>
      </div>
    </Paper>
  ) : (
    <AuditItem
      inventory={currentInventory}
      handleComplete={handleComplete}
      handleSkip={handleSkip}
      setListMode={setListMode}
      isCompleted={
        currentAudit.processedItems.findIndex(
          (itm) => itm.id === currentInventory.id
        ) >= 0
      }
    />
  );
};

const SplitButton = ({ returnToAudit, setLocationMode }) => {
  const [open, setOpen] = React.useState(false);
  const [selectedItem, setSelectedItem] = React.useState("Close");
  const anchorRef = React.useRef(null);

  const handleClick = () => {
    handleMenuItemClick(selectedItem);
  };

  const handleMenuItemClick = (val) => {
    setOpen(false);
    setSelectedItem(val);
    if (val === "Close") returnToAudit();
    else setLocationMode(true);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  return (
    <Grid container direction="column" alignItems="center">
      <Grid item xs={12}>
        <ButtonGroup ref={anchorRef}>
          <Button onClick={handleClick} size="large">
            {selectedItem}
          </Button>
          <Button size="large" onClick={handleToggle}>
            <DropDownIcon />
          </Button>
        </ButtonGroup>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList id="split-button-menu">
                    <MenuItem
                      selected
                      onClick={() => handleMenuItemClick("Close")}
                    >
                      Close
                    </MenuItem>
                    <MenuItem
                      onClick={() => handleMenuItemClick("Select location")}
                    >
                      Select location
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </Grid>
    </Grid>
  );
};
